import { Component, OnInit } from '@angular/core';
import { LanguageService } from './services';

@Component({
  selector: 'esc-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {

  public moduleName;

  constructor(
    language: LanguageService) {
    language.initLocale();
  }

  ngOnInit(): void {
  }

}
